import { customerFilter, materialFilter } from '@/config/filterDefinitions';

// Filter definitions for <OutgoingShipmentsPage>; each field is one OutgoingShipmentFilters accepts.
export const OUTGOING_SHIPMENT_FILTERS = Object.freeze({
  materialId: 'materialId',
  customerAccountId: 'customerAccountId',
});

export const buildOutgoingShipmentFilterDefinitions = (
  t,
  { materialOptions, customerOptions } = {},
) => [
  ...materialFilter(t, OUTGOING_SHIPMENT_FILTERS.materialId, materialOptions),
  ...customerFilter(t, OUTGOING_SHIPMENT_FILTERS.customerAccountId, customerOptions),
];
